import { Flag, ToggleLeft, ToggleRight } from 'lucide-react';
import { PageHeader, ScaffoldBanner, Section } from '../components/Scaffold';

/**
 * Feature flags — PLANNED capability.
 *
 * Listed in the KT as a SuperAdmin capability (roll a feature to a single
 * tenant before global launch) but there is NO backend model/endpoint yet.
 * Scaffold so the design covers it; backend must be built before wiring.
 */
const FLAGS = [
  { key: 'cashfree_embedded_checkout', desc: 'Embedded Cashfree checkout', scope: 'Whitelist', on: false },
  { key: 'new_leaderboard_ui', desc: 'Revamped leaderboard', scope: '3 cafés', on: true },
  { key: 'flutter_push_v2', desc: 'New mobile push pipeline', scope: 'Global', on: true },
];

export default function FeatureFlags() {
  return (
    <div className="page feature-flags-page">
      <style>{`
        .feature-flags-page {
          /* noLag rebrand: scoped to this page only. No Figma node exists
             for Feature Flags — applied by the same accent-only pattern as
             the other scaffold pages this session. */
          --accent-primary: #FE7B00;
          --accent-primary-rgb: 254, 123, 0;
          --accent-primary-glow: rgba(254, 123, 0, 0.25);
          --accent-primary-subtle: rgba(254, 123, 0, 0.12);
          --accent-gradient: linear-gradient(135deg, #FE7B00 0%, #F7302F 100%);
        }
      `}</style>
      <PageHeader title="Feature Flags" subtitle="Roll features to a tenant before global launch" />

      <ScaffoldBanner
        status="planned"
        note="No FeatureFlag model/endpoint exists in the backend yet. Build a global flags table + GET/PUT endpoints, then wire this screen."
      />

      <Section title="Flags">
        <div className="card table-card">
          <table className="data-table">
            <thead>
              <tr>
                <th>Flag</th>
                <th>Description</th>
                <th>Scope</th>
                <th style={{ textAlign: 'right' }}>State</th>
              </tr>
            </thead>
            <tbody>
              {FLAGS.map((f) => (
                <tr key={f.key}>
                  <td className="font-mono"><Flag size={14} /> {f.key}</td>
                  <td className="text-secondary">{f.desc}</td>
                  <td><span className="badge badge--neutral">{f.scope}</span></td>
                  <td style={{ textAlign: 'right' }}>
                    {f.on
                      ? <ToggleRight size={22} color="var(--status-success)" />
                      : <ToggleLeft size={22} color="var(--text-quaternary)" />}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Section>
    </div>
  );
}
